// eslint-disable-next-line import/prefer-default-export
export const selectURL = (state) => state.get('url') || '';
